import React from 'react'

import { ListSelector } from '~/client/src/shared/components/ListSelector'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/client/src/shared/components/shadcn-ui/popover'

interface IProps {
  children?: React.ReactNode
  content: string | JSX.Element | ((close: () => void) => JSX.Element)
  title: string
}

const PopoverComponent: React.FC<IProps> = ({ children, content, title }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const bodyRef = React.useRef<HTMLDivElement>(null)
  const close = () => setIsOpen(false)
  const focusFirstBodyControl = () =>
    bodyRef.current?.querySelector<HTMLElement>(
      'input, textarea, select, button, [tabindex]:not([tabindex="-1"])',
    ) ?? true

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger
        nativeButton={false}
        render={<span className="no-grow mr10 w20 h20" tabIndex={-1} />}
      >
        {children}
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="start"
        className="tw:w-auto tw:p-0 tw:gap-0 tw:overflow-hidden"
        initialFocus={focusFirstBodyControl}
      >
        <ListSelector.Title title={title} onClose={close} />
        <div ref={bodyRef}>
          {typeof content === 'function' ? content(close) : content}
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default PopoverComponent
